import { SearchFilter, SearchFilterId } from "../../../../redux-magic/sub-interfaces/search-types";

import {
	amenities,
	area,
	available_from,
	balconies,
	balconies_variant_2,
	bathrooms,
	bathrooms_variant_2,
	bedrooms,
	bedrooms_variant_2,
	budget,
	business_profile_type,
	floors,
	furnishing,
	land_facing,
	listed_by,
	location,
	plot_dimensions,
	possession_date,
	property_category,
	property_title,
	property_status,
	property_type,
	search_type,
	SearchFiltersConfig,
	seats,
	security_deposit,
	service_category,
	service_subtype,
	service_type,
	transaction_type,
	unit_facing,
} from "../index";

const bedroomsVariant: SearchFilter = SearchFiltersConfig.bedrooms.enabled ? bedrooms : bedrooms_variant_2;
const bathroomsVariant: SearchFilter = SearchFiltersConfig.bathrooms.enabled ? bathrooms : bathrooms_variant_2;
const balconiesVariant: SearchFilter = SearchFiltersConfig.balconies.enabled ? balconies : balconies_variant_2;

export const SearchFiltersMap: Map<SearchFilterId, SearchFilter> = new Map([
	[property_title.id, property_title],
	[search_type.id, search_type],
	[location.id, location],
	[transaction_type.id, transaction_type],
	[property_category.id, property_category],
	[property_type.id, property_type],
	[budget.id, budget],
	[security_deposit.id, security_deposit],
	[bedrooms.id, bedroomsVariant],
	[bedrooms_variant_2.id, bedroomsVariant],
	[area.id, area],
	[bathrooms.id, bathroomsVariant],
	[bathrooms_variant_2.id, bathroomsVariant],
	[balconies.id, balconiesVariant],
	[balconies_variant_2.id, balconiesVariant],
	[seats.id, seats],
	[plot_dimensions.id, plot_dimensions],
	[property_status.id, property_status],
	[possession_date.id, possession_date],
	[available_from.id, available_from],
	[unit_facing.id, unit_facing],
	[land_facing.id, land_facing],
	[floors.id, floors],
	[furnishing.id, furnishing],
	[amenities.id, amenities],
	[service_category.id, service_category],
	[service_type.id, service_type],
	[service_subtype.id, service_subtype],
	[listed_by.id, listed_by],
	[business_profile_type.id, business_profile_type],
]);

export const SearchFiltersMapTest: Map<SearchFilterId, SearchFilter> = new Map([
	[property_title.id, property_title],
	[search_type.id, search_type],
	[location.id, location],
	[transaction_type.id, transaction_type],
	[property_category.id, property_category],
	[property_type.id, property_type],
	[budget.id, budget],
	[security_deposit.id, security_deposit],
	[bedrooms.id, bedroomsVariant],
	[bedrooms_variant_2.id, bedroomsVariant],
	[area.id, area],
	[bathrooms.id, bathroomsVariant],
	[bathrooms_variant_2.id, bathroomsVariant],
	[balconies.id, balconiesVariant],
	[balconies_variant_2.id, balconiesVariant],
	[seats.id, seats],
	[plot_dimensions.id, plot_dimensions],
	[property_status.id, property_status],
	[possession_date.id, possession_date],
	[available_from.id, available_from],
	[unit_facing.id, unit_facing],
	[land_facing.id, land_facing],
	[floors.id, { ...floors, is_applied: true }],
	[furnishing.id, furnishing],
	[amenities.id, amenities],
	[service_category.id, service_category],
	[service_type.id, service_type],
	[service_subtype.id, service_subtype],
	[listed_by.id, listed_by],
	[business_profile_type.id, business_profile_type],
]);
